module.exports = __webpack_public_path__ + "static/media/jttreasurer.4e707b0c.jpg";